import React from 'react'
import PropTypes from 'prop-types'
import styles from './InitialsBubble.module.scss'

const InitialsBubble = (props) => {
  const {
    initials,
    size,
  } = props

  return (
    <div data-test-id="initialsBubble" className={styles.container}>
      <div className={styles[size]}>
        <p>{initials}</p>
      </div>
    </div>
  )
}

InitialsBubble.defaultProps = {
  size: 'large',
}

InitialsBubble.propTypes = {
  initials: PropTypes.string.isRequired,
  size: PropTypes.oneOf([
    'medium',
    'large',
  ])
}

export default InitialsBubble



// WEBPACK FOOTER //
// ./src/components/Client/Shared/InitialsBubble/InitialsBubble.jsx